import type { FunctionComponent } from 'react';

import { Spinner } from '@trello/nachos/spinner';

import styles from './InboxSkeleton.less';

export const InboxSkeleton: FunctionComponent = () => {
  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
};
